module.exports = __webpack_public_path__ + "img/image45.0866e493.jpg";